import LayerSelect from "../../Palettes/Propertybar/input/layerSelect";
import { PropsWithChildren } from 'react'

type ShapePaletteProps = {
  shapeId: number
}

const ShapePalette = ({ shapeId, children }: PropsWithChildren<ShapePaletteProps>) => {

  return (
    <>
      {children}
      <LayerSelect shapeId={shapeId} />
    </>
  )
}


export default ShapePalette;